import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.message',
    defaultMessage:
      'Get fancy. Brand employee surveys with your logo, colors, and a white label URL.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.ctaText',
    defaultMessage: 'See plan options',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.messageCollect',
    defaultMessage:
      'Integrate employee feedback with your HRIS and make it part of your business systems.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.ctaTextCollect',
    defaultMessage: 'Upgrade now',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.messageAnalyze',
    defaultMessage:
      'Uncover patterns in employee feedback with crosstabs, filters, and text analysis.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseEmployeeEngagementTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseEmployeeEngagementTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseEmployeeEngagementTopBarSlim: React.FC<UseCaseEmployeeEngagementTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_employee_engagement`
    : 'slim_create_upsell_employee_engagement';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseEmployeeEngagementTopBarSlim;
